import {ApplicationConfig} from '@angular/core';
import {provideRouter} from '@angular/router';
import {routes} from './app.routes';
import {initializeApp, provideFirebaseApp} from '@angular/fire/app';
import {connectFirestoreEmulator, getFirestore, provideFirestore} from '@angular/fire/firestore';
import {getPerformance, providePerformance} from '@angular/fire/performance';
import {connectStorageEmulator, getStorage, provideStorage} from '@angular/fire/storage';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {WINDOW_PROVIDER} from "./window";
import {environment} from "../environments/environment.prod";
import {connectFunctionsEmulator, getFunctions, provideFunctions} from "@angular/fire/functions";
import { provideShareButtonsOptions } from 'ngx-sharebuttons';
import { withIcons } from 'ngx-sharebuttons/icons';

export const appConfig: ApplicationConfig = {
  providers: [provideShareButtonsOptions(
    withIcons()),
    provideRouter(routes),
    provideFirebaseApp(() => initializeApp(
      environment.firebaseInitializationConfig)),
    WINDOW_PROVIDER,
    provideFirestore(() => {
      const  firestore = getFirestore();
      // if (location.hostname === 'localhost'|| location.hostname === '127.0.0.1') {
      //   connectFirestoreEmulator(firestore, '127.0.0.1', 8080);
      // }
      return  firestore;
    }),
    providePerformance(() => getPerformance()),
    provideStorage(() => {
      const  storage = getStorage();
      // if (location.hostname === 'localhost'|| location.hostname === '127.0.0.1') {
      //   connectStorageEmulator(storage, '127.0.0.1', 9199);
      // }
      return  storage;
    }),
    provideFunctions(() => {
      const  functions = getFunctions(undefined, 'us-east4');
      // if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
      //   connectFunctionsEmulator(functions, '127.0.0.1', 5001);
      // }
      return  functions;
    }),
    provideAnimationsAsync()]
};
